(function() {
  const swiperInstances = new Map();

  function initSlider(slider) {
    const config = JSON.parse(slider.dataset.swiperConfig);
    const swiperEl = slider.querySelector('.swiper');
    
    if (!swiperEl) return;

    // Destroy existing instance if any
    if (swiperInstances.has(slider)) {
      swiperInstances.get(slider).destroy(true, true);
      swiperInstances.delete(slider);
    }

    const paginationEl = slider.querySelector('.ctr-energy-testimonials__pagination');
    const nextEl = slider.querySelector('.ctr-energy-testimonials__nav-next');
    const prevEl = slider.querySelector('.ctr-energy-testimonials__nav-prev');
    const overlayLayout = Boolean(slider.closest('.ctr-energy-testimonials--overlay'));
    const slidesPerViewAuto = config.slidesPerViewAuto || overlayLayout;
    const baseGap = Number(config.slideGap) || 0;
    // Overlay layout scales proportionally above 1440px (matches the fluid CSS)
    const getGap = function() {
      if (!overlayLayout || window.innerWidth <= 1440) return baseGap;
      return Math.round(baseGap * window.innerWidth / 1440 * 10) / 10;
    };
    const slideGap = getGap();

    const swiperOptions = {
      slidesPerView: slidesPerViewAuto ? 'auto' : config.slidesPerViewMobile,
      spaceBetween: slideGap,
      loop: config.loop,
      watchOverflow: true
    };

    if (paginationEl) {
      swiperOptions.pagination = {
        el: paginationEl,
        clickable: true,
        bulletClass: 'swiper-pagination-bullet',
        bulletActiveClass: 'swiper-pagination-bullet-active'
      };
    }

    if (nextEl && prevEl) {
      swiperOptions.navigation = {
        nextEl: nextEl,
        prevEl: prevEl
      };
    }

    swiperOptions.breakpoints = {
      768: {
        slidesPerView: slidesPerViewAuto ? 'auto' : config.slidesPerView
      }
    };
    if (!overlayLayout) swiperOptions.breakpoints[768].spaceBetween = slideGap;

    if (config.autoplay) {
      swiperOptions.autoplay = {
        delay: config.autoplaySpeed,
        disableOnInteraction: false,
        pauseOnMouseEnter: true
      };
    }

    if (overlayLayout) {
      swiperOptions.on = {
        resize: function(sw) {
          const gap = getGap();
          if (sw.params.spaceBetween !== gap) {
            sw.params.spaceBetween = gap;
            sw.update();
          }
        }
      };
    }

    const swiper = new Swiper(swiperEl, swiperOptions);
    swiperInstances.set(slider, swiper);
    
    return swiper;
  }

  function initAllSliders() {
    document.querySelectorAll('.ctr-energy-testimonials__slider[data-swiper-config]').forEach(function(slider) {
      initSlider(slider);
    });
  }

  function destroySlider(slider) {
    if (swiperInstances.has(slider)) {
      swiperInstances.get(slider).destroy(true, true);
      swiperInstances.delete(slider);
    }
  }

  function getSectionSlider(sectionId) {
    return document.querySelector(`.ctr-energy-testimonials--${sectionId} .ctr-energy-testimonials__slider[data-swiper-config]`);
  }

  // Initialize on DOM ready
  document.addEventListener('DOMContentLoaded', initAllSliders);

  // Shopify Theme Editor Events
  document.addEventListener('shopify:section:load', function(event) {
    const slider = event.target.querySelector('.ctr-energy-testimonials__slider[data-swiper-config]');
    if (slider) {
      initSlider(slider);
    }
  });

  document.addEventListener('shopify:section:unload', function(event) {
    const slider = event.target.querySelector('.ctr-energy-testimonials__slider[data-swiper-config]');
    if (slider) {
      destroySlider(slider);
    }
  });

  document.addEventListener('shopify:section:select', function(event) {
    const slider = event.target.querySelector('.ctr-energy-testimonials__slider[data-swiper-config]');
    if (slider && swiperInstances.has(slider)) {
      const swiper = swiperInstances.get(slider);
      if (swiper.autoplay && swiper.autoplay.running) {
        swiper.autoplay.stop();
      }
    }
  });

  document.addEventListener('shopify:section:deselect', function(event) {
    const slider = event.target.querySelector('.ctr-energy-testimonials__slider[data-swiper-config]');
    if (slider && swiperInstances.has(slider)) {
      const swiper = swiperInstances.get(slider);
      const config = JSON.parse(slider.dataset.swiperConfig);
      if (config.autoplay && swiper.autoplay) {
        swiper.autoplay.start();
      }
    }
  });

  document.addEventListener('shopify:block:select', function(event) {
    const slider = event.target.closest('.ctr-energy-testimonials__slider[data-swiper-config]');
    if (slider && swiperInstances.has(slider)) {
      const swiper = swiperInstances.get(slider);
      const slide = event.target.closest('.swiper-slide');
      
      if (slide) {
        const slideIndex = Array.from(slider.querySelectorAll('.swiper-slide:not(.swiper-slide-duplicate)')).indexOf(slide);
        if (slideIndex !== -1) {
          swiper.slideToLoop(slideIndex);
        }
      }
      
      if (swiper.autoplay && swiper.autoplay.running) {
        swiper.autoplay.stop();
      }
    }
  });

  document.addEventListener('shopify:block:deselect', function(event) {
    const slider = event.target.closest('.ctr-energy-testimonials__slider[data-swiper-config]');
    if (slider && swiperInstances.has(slider)) {
      const swiper = swiperInstances.get(slider);
      const config = JSON.parse(slider.dataset.swiperConfig);
      if (config.autoplay && swiper.autoplay) {
        swiper.autoplay.start();
      }
    }
  });
})();
